/*
 * AgeValidationReliable Messages
 *
 * This contains all the text for the AgeValidationReliable component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'app.components.AgeValidationReliable.title',
    defaultMessage: 'Validá tu edad',
  },
  subtitle: {
    id: 'app.components.AgeValidationReliable.subtitle',
    defaultMessage:
      'Para continuar con tu compra, confirmá que sos mayor de edad ingresando estos datos.',
  },
  inputTitle: {
    id: 'app.components.AgeValidationReliable.inputTitle',
    defaultMessage: 'Número de DNI',
  },
  inputError: {
    id: 'app.components.AgeValidationReliable.inputError',
    defaultMessage: 'El DNI que ingresaste no es válido',
  },
  pickerTitle: {
    id: 'app.components.AgeValidationReliable.pickerTitle',
    defaultMessage: 'Tu fecha de nacimiento',
  },
  acceptButton: {
    id: 'app.components.AgeValidationReliable.acceptButton',
    defaultMessage: 'Confirmar',
  },
  cancelButton: {
    id: 'app.components.AgeValidationReliable.cancelButton',
    defaultMessage: 'Volver',
  },
  errorDate: {
    id: 'app.components.AgeValidationReliable.errorDate',
    defaultMessage: 'La fecha ingresada no es válida',
  },
  dateNotMatch: {
    id: 'app.components.AgeValidationReliable.dateNotMatch',
    defaultMessage:
      'Tu fecha de nacimiento no coincide con el DNI que ingresaste.',
  },
});
